// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datacard {
  width: 100%;
  border-bottom: 1px solid #353535;
  margin-top: 10px;
  font-style: italic;
}
.datacard h2 {
  font-size: 20px;
  font-weight: bold;
  color: #353535;
}
.datacard h3 {
  font-size: 14px;
  font-weight: 300;
  color: #353535;
}
.datacarddesc {
  margin-bottom: 10px;
}
.datacarddesc p {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/DataCardHeader.less"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAHA;EAOM,eAAA;EACA,iBAAA;EACA,cAAA;AADN;AARA;EAaM,eAAA;EACA,gBAAA;EACA,cAAA;AAFN;AAMA;EACE,mBAAA;AAJF;AAGA;EAII,eAAA;AAJJ","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.datacard {\n    width: 100%;\n    border-bottom: 1px solid @background-dark1;\n    margin-top: 10px;\n    font-style: italic;\n\n    h2 {\n      font-size: 20px;\n      font-weight: bold;\n      color: @text-gray1;\n    }\n\n    h3 {\n      font-size: 14px;\n      font-weight: 300;\n      color: @text-gray1;\n    }\n}\n\n.datacarddesc {\n  margin-bottom: 10px;\n\n  p {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
